module.exports = __webpack_public_path__ + "img/white_ic_invoices.018edaef.svg";